import React from 'react';
import PropTypes from 'prop-types';
import {camelCase, isEmpty} from "lodash";
import {camelizeKeys, camelizeKeysDeep} from "../../../../ReduxStore/Helpers/transformObject";
import {getClassList} from "../../../../Utility/siteConfig";
import CartPriceDisplay from "./CartPriceDisplay";
import DynamicAddButton from "../../DynamicAddButton";
import CheckoutLink from "../../StandardItems/CheckoutLink";

/*
 * 2025-10 AddToCartForm merged into this.
 */
export default function ClusterAddToCart({
  clusterState = {},
  products,
  shoppingCart,
  cartItem,
}) {
  // 2025-02 not camelized above here.
  let selectedItem = camelizeKeysDeep(clusterState.selectedItem);
  let matchingProducts = camelizeKeysDeep(clusterState.matchingProducts);

  let product = selectedItem?.product;
  let outOfStock = isOutOfStock(product);

  let enabled = !!selectedItem && !isEmpty(product) && !outOfStock;

  let className = getClassList({
    key: 'AddToCartForm',
    base: ["text-lg lg:text-base lg:text-right",
      outOfStock ? 'out-of-stock' : null
    ]
  });

  return <div className={className}>
    <CartPriceDisplay
      product={product}
      products={products}
      matchingProducts={matchingProducts}
    />

    <div className="text-right">
      <DynamicAddButton
        disabled={!enabled}
        product={product}
        application={selectedItem?.application}
        className="mt-0 w-full lg:w-3/4 inline-block"/>
    </div>

    {cartItem && <CheckoutLink shoppingCart={shoppingCart}/>}

    {outOfStock && <div className="text-red-800 font-bold">Out Of Stock</div>}
  </div>
}

ClusterAddToCart.propTypes = {
  itemApplications: PropTypes.array,
  products: PropTypes.object.isRequired,
  // productGroup: PropTypes.object.isRequired,
  // dispatch,
  pageType: PropTypes.string, // "CMf"
  cluster: PropTypes.object,
  clusterState: PropTypes.object,
  itemCache: PropTypes.object, // AppliedItemCache
  cartItem: PropTypes.object
}

function isOutOfStock(product) {
  if (!product) return false;

  let status = camelCase(product.buyableStatus);
  return (status === "outOfStock") || (status === 'discontinued');
}
